import ServiceTemplate from '@/components/ServiceTemplate';

export default function IssueShares() {
  const data = {
    title: 'Share Issuance Services',
    subtitle: 'Professional stock issuance and capitalization services for corporations.',
    overviewTitle: 'Why Proper Share Issuance Matters',
    overviewImage: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72',
    description: [
      'Properly issuing shares is crucial for corporations to establish ownership, raise capital, and maintain corporate formalities. Incorrect issuance can jeopardize liability protection and create tax complications.',
      'Our share issuance service handles all aspects of stock issuance including determining valuation, preparing stock certificates, updating capitalization tables, and ensuring securities law compliance.',
      'We ensure your stock issuance is properly documented and compliant with both corporate law and securities regulations.'
    ],
    benefits: [
      { title: 'Legal Compliance', description: 'Ensure compliance with corporate and securities law.' },
      { title: 'Proper Documentation', description: 'Complete stock certificates and corporate records.' },
      { title: 'Capitalization Table', description: 'Maintain accurate cap table records.' },
      { title: 'Valuation Support', description: 'Assist with proper stock valuation.' },
      { title: 'Securities Compliance', description: 'Navigate securities law requirements.' },
      { title: 'Investor Ready', description: 'Prepare documentation for future investment.' }
    ],
    process: [
      { title: 'Transfer Planning & Documentation', description: 'Review requirements and prepare comprehensive transfer agreements and documents.' },
      { title: 'Execution & Verification', description: 'Coordinate proper execution, notarization, and verification of all transfer documents.' },
      { title: 'Recording & Compliance', description: 'File and record transfers with appropriate authorities and ensure ongoing compliance.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential formation',
        price: '$299',
        period: '+ state fees',
        features: [
          'Entity formation filing',
          'Name availability check',
          'EIN application',
          'Basic documents',
          'Email support',
          'Document delivery'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete package',
        price: '$599',
        period: '+ state fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Custom agreements',
          'Tax consultation',
          'Compliance setup',
          'Registered agent (1 year)',
          'Priority processing',
          'Phone support'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Full-service solution',
        price: '$999',
        period: '+ state fees',
        features: [
          'Everything in Professional',
          'Multi-state filing',
          'Advanced structuring',
          'Annual compliance',
          'Quarterly reviews',
          'Dedicated attorney',
          'Unlimited consultations'
        ]
      }
    ],
    faqs: [
      { question: 'How many shares should I authorize?', answer: 'Companies typically authorize more shares than initially issued to allow for future investment without amending articles. Common starting point is 10 million shares.' },
      { question: 'What is par value?', answer: 'Par value is the minimum price per share set in articles of incorporation. Many states allow no-par or nominal par value (e.g., $0.0001/share).' },
      { question: 'How do I value shares?', answer: 'Early-stage companies often issue at par value. As companies grow, 409A valuations may be required for tax compliance.' },
      { question: 'What are different share classes?', answer: 'Common stock is standard ownership; preferred stock may have special rights like preferences in liquidation or voting.' },
      { question: 'Do I need to issue certificates?', answer: 'Physical certificates aren\'t required but are traditional. Many companies now maintain electronic records only.' },
      { question: 'What securities law applies?', answer: 'Federal and state securities laws apply. Initial founder issuance typically qualifies for exemptions, but investor rounds require compliance analysis.' },
      { question: 'What is a capitalization table?', answer: 'A cap table tracks all company securities, ownership percentages, and fully-diluted ownership for each shareholder.' },
      { question: 'Can I issue shares for services?', answer: 'Yes, shares can be issued for cash, property, or services, though proper valuation and documentation are essential for tax compliance.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
